import LondonImage from "../assets/branches/london.jpeg";
import HydImage from "../assets/branches/hyd.avif";
import BangaloreImage from "../assets/branches/banglore.jpg";

export const OurBranches = [
  {
    city: "Hyderabad",
    state: "Telangana",
    country: "India",
    address: "Hyderabad, Telangana, India",
    mapLink: "https://maps.app.goo.gl/WKh4hJL8neAKdU8y5",
    image: HydImage,
    phone: "+91 93477 91837",
  },

  // Karnataka, India
  {
    city: "Bangalore",
    state: "Karnataka",
    country: "India",
    address: "Bangalore, Karnataka, India",
    mapLink: "https://maps.app.goo.gl/3x9WUxXmR5FMsdb77",
    image: BangaloreImage,
    phone: "+91 974 974 9596",
  },
  // London
  {
    city: "London",
    state: "North London",
    country: "London",
    address: "297,Suite 2, High Street North London,",
    mapLink: "https://maps.app.goo.gl/GBmr3J235rNo4Tog6",
    image: LondonImage,
    phone: " +44 20 3161 8413",
  },
];
